import React from 'react';
import InputFlexBox from 'components/container/InputFlexBox';
import styled from 'styled-components';
import { ISupportLanguage } from 'utils/types/storyTypes';
import FormRightContent from './FormRightContent';
import Content from './Content';

interface IProps {
  langList: ISupportLanguage[] | null;
  data: any;
  setData: React.Dispatch<React.SetStateAction<any | null>>;
  projectId: string | undefined;
}

const ContentWrapper: React.FC<IProps> = ({
  langList,
  data,
  setData,
  projectId,
}) => {
  return (
    <div>
      <InputFlexBox>
        <ListFormLeftWrapping>
          <Content
            langList={langList}
            data={data}
            setData={setData}
            projectId={projectId}
          />
        </ListFormLeftWrapping>
        <ListFormRightWrapping>
          <FormRightContent
            data={data}
            setData={setData}
            projectId={projectId}
          />
        </ListFormRightWrapping>
      </InputFlexBox>
    </div>
  );
};

export default ContentWrapper;

const ListFormLeftWrapping = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  row-gap: 24px;
  margin-right: 1.5rem;
`;
const ListFormRightWrapping = styled.div`
  width: 100%;
`;
